import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Keyboard, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import './style.scss';

function Carousel(props) {
  const swiperRef = React.useRef();
  const [navigationButtonsNeeded, setNavigationButtonsNeeded] = React.useState(false);

  React.useEffect(() => {
    if (!swiperRef.current || !props.activeTabName) {
      return;
    }

    props.children.forEach((child, i) => {
      if (i !== 0 && child.key === props.activeTabName) {
        const slideOffset = Math.round(swiperRef.current?.visibleSlidesIndexes?.length / 2) - 1;
        swiperRef.current?.slideTo(Math.max(0, i - slideOffset));
      }
    });
  }, [props.activeTabName, props.children]);

  return (
    <Swiper
      onSwiper={swiper => {
        swiperRef.current = swiper;
        if (swiper.visibleSlides?.length < swiper.slides.length) {
          setNavigationButtonsNeeded(true);
        }
      }}
      keyboard={{
        enabled: true,
      }}
      navigation={true}
      modules={[Keyboard, Navigation]}
      spaceBetween={0}
      slidesPerView={'auto'}
      watchSlidesProgress
      className={`${navigationButtonsNeeded ? 'with-navigation-buttons' : ''}`}
    >
      {props.children.map((c, i) => (
        <SwiperSlide
          key={i}
          onFocus={() => {
            if (!swiperRef.current) {
              return;
            }
            swiperRef.current?.slideTo(i);
          }}
        >
          {c}
        </SwiperSlide>
      ))}
    </Swiper>
  );
}

export default Carousel;
